import compact from "lodash/compact";
import nth from "lodash/nth";
import { ApiFilterGroupV2, FilterKeyV2, FilterPathV2, KnownFiltersV2 } from "PFTypes/filters_v2";

export const buildOriginalFilterPath = (
  group: ApiFilterGroupV2,
  name: FilterKeyV2,
  { addChildrenPrefix }: { addChildrenPrefix?: boolean } = {}
): FilterPathV2 =>
  compact([addChildrenPrefix && "children", group, group !== ApiFilterGroupV2.Availability && name]).join(
    "."
  ) as FilterPathV2;

export const getFilterGroupAndName = (
  filterPath: FilterPathV2
): { group: ApiFilterGroupV2; name: FilterKeyV2 } => {
  if (
    filterPath === ApiFilterGroupV2.Availability ||
    filterPath === `children.${ApiFilterGroupV2.Availability}`
  ) {
    return { group: ApiFilterGroupV2.Availability, name: KnownFiltersV2.Availability };
  }

  const parts = filterPath.split(".");

  return { group: nth(parts, -1) as ApiFilterGroupV2, name: nth(parts, -2) as FilterKeyV2 };
};
